import React from 'react'
import ScopeChangeRequest, {
  ScopeChangeRequestResponse,
  ResponseType,
} from 'admin/scope-change-requests/ScopeChangeRequest'
import Avatar from 'components/Avatar'
import {
  Section,
  SectionContent,
  SectionHeader,
  SectionTitleSuffix,
  useSection,
} from 'components/Section'
import { observer } from 'mobx-react'
import ScopeChangeRequestDetailsViewModel from '../ScopeChangeRequestDetailsViewModel'
import { formatSentDate } from 'admin/scope-change-requests/formatters/scope-change-request-response-formatters'
import styles from './ResponsesSection.sass'

interface ChangeRequestReasonItemProps {
  scopeChangeRequest: ScopeChangeRequest
}

const ChangeRequestReasonItem = observer(function ChangeRequestReason({
  scopeChangeRequest,
}: ChangeRequestReasonItemProps) {
  return (
    <div className={styles.responseRoot}>
      <div className={styles.responseUser}>
        <Avatar subject={scopeChangeRequest.createdBy} size={24} />
        <div className={styles.responseUserName}>
          {scopeChangeRequest.createdBy.displayName}
        </div>

        <div className={styles.separator}>•</div>
        <div className={styles.responseUserType}>
          {scopeChangeRequest.reasonCollaboratorType}
        </div>
      </div>
      <div className={styles.response}>{scopeChangeRequest.reason}</div>
      <div className={styles.responseDate}>
        {'Created'} {formatSentDate(scopeChangeRequest.createTime)}
      </div>
    </div>
  )
})

interface ChangeRequestResponseItemProps {
  response: ScopeChangeRequestResponse
}

const ChangeRequestResponseItem = observer(function ChangeRequestResponse({
  response,
}: ChangeRequestResponseItemProps) {
  return (
    <div className={styles.responseRoot}>
      <div className={styles.responseUser}>
        <Avatar subject={response.createdByUser} size={24} />
        <div className={styles.responseUserName}>
          {response.createdByUser.displayName}
        </div>

        <div className={styles.separator}>•</div>
        <div className={styles.responseUserType}>{response.responderUser}</div>
      </div>
      <div className={styles.response}>{response.reason}</div>
      <div className={styles.responseDate}>
        {response.responseType === ResponseType.Approved
          ? 'Approved'
          : 'Rejected'}{' '}
        {formatSentDate(response.dateCreated)}
      </div>
    </div>
  )
})

interface ResponsesSectionProps {
  vm: ScopeChangeRequestDetailsViewModel
}

export default observer(function ResponsesSection({
  vm,
}: ResponsesSectionProps) {
  const sectionProps = useSection(false)

  return (
    <Section {...sectionProps}>
      <SectionHeader>
        Responses{' '}
        <SectionTitleSuffix>
          ({vm.scopeChangeRequest.responders.length + 1})
        </SectionTitleSuffix>
      </SectionHeader>
      <SectionContent>
        {vm.scopeChangeRequest.hasResponders &&
          vm.scopeChangeRequest.responders.map((r, i) => (
            <ChangeRequestResponseItem key={i} response={r} />
          ))}
        <ChangeRequestReasonItem scopeChangeRequest={vm.scopeChangeRequest} />
      </SectionContent>
    </Section>
  )
})
